<template>
  <div style="width: 100vw;height: auto;background-color: #f4f7f9;position: relative;overflow: hidden"
       class="whole-page">
    <div class="header">
      <div class="header-icon" @click="$router.push('/')"></div>
      <div class="header-title">学生端虚拟实验模考系统</div>
      <div class="header-pic"
           @click="clickZone">
        <div class="user-card"
             ref="user-card-list"
             v-if="showCard">
          <div class="user-card-pic"></div>
          
            <div style="position:absolute;z-index:999">
              <div class="user-msg">
                <span style="margin-bottom: 0.2vw;display: inline-block">{{username}}</span><br>
                <span>{{'ID：'+(account.length>7?account.slice(0,7)+'...':account)}}</span>
              </div>
            </div>
          
          <div class="user-btn-list">
            <div class="user-card-btn"
                 @click="changeRight('toHome')">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
              <div class="user-btn-text">个人中心</div>
            </div>
            <div class="user-card-btn"
                 @click="changeRight('exit')">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/安全退出icon.png">
              <div class="user-btn-text"
                   @click="logout=true">安全退出</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="teacher-body">
      <div class="teacher-body-left">
        <div class="switch-classroom">
          <div class="icon-classroom"></div>
          <div style="line-height: 40px;height: 40px;white-space: nowrap;width: 3vw;font-size: 0.8vw">班级：</div>
          <div class=""
               style="margin: auto;width: 8vw;font-size: 0.8vw">{{student.classroom.name}}</div>
        </div>
        <div class="router-btn-group">
          <div class="router-btn"
               v-for="item in routerList"
               @mouseenter="item.active=true"
               @mouseleave="item.active=item.active&&page===item.name"
               @click="switchPage(item.name)">
            <img :src="'http://data.xiyilab.com/web/main/static'+(item.active?item.icon+'_L.png':(item.icon+'_N.png'))"
                 class="router-btn-icon">
            <div class="router-btn-text"
                 :style="{color:item.active?'#5eb2f7':'black'}">{{item.name}}</div>
            <div class="router-btn-right-line"
                 :style="{visibility:item.active?'inherit':'hidden'}"></div>
          </div>
        </div>
      </div>


      <div class="teacher-body-right" v-if="page==='自主练习'" style="justify-content: flex-start">

        <div class="select-app-card">
          <div class="task-name-input">
            <span> 实验名称：</span>
            <el-input placeholder="请输入实验名称"
                      v-model="searchAppInput"
                      style="width: 20vw;max-width: 400px">
              <i class="el-icon-close clear-btn" slot="suffix" v-if="searchAppInput.length>0" @click="searchAppInput=''"></i>
              <i class="search-btn"
                 slot="suffix"
                 @click="searchApp"></i>
            </el-input>
          </div>
          <div class="subject-select-btn-group">
            <span>科目选择：</span>
            <el-checkbox :indeterminate="isIndeterminate"
                         v-model="checkAll"
                         @change="handleCheckAllChange"
                         style="margin-right: 1vw;margin-left: 1vw">全选</el-checkbox>
            <el-checkbox-group v-model="checkedCities"
                               @change="handleCheckedCitiesChange">
              <el-checkbox v-for="subject in subjects"
                           :label="subject"
                           :key="subject">{{subject}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="width: 100%;height: 1px ;background-color: silver;margin:1vw auto"></div>
        </div>

        <div v-if="appList.findIndex(item=>item.show===true)===-1"
             class="search-no-result-img">
        </div>

        <div class="app-body" style="overflow: auto">
          <div class="app-card"
               v-for="(item,index) in appList"
               v-if="item.show"
               @click="openExcel(item)">
            <div class="app-icon" :class="{'phy-back':item.subject==='物理','chem-back':item.subject==='化学','bio-back':item.subject==='生物'}" style="position: relative;overflow: hidden">
              <div class="skin" v-if="isSeller&&!whiteList.find(i=>i==item.name)">
                <div class="skin-cir">
                  <div class="skin-lock"></div>
                  <div class="skin-title"></div>
                </div>

              </div>
              <img :src="item['platforms'][0]['preview_img_uri']"
                   width="120"
                   height="120">
            </div>
            <div class="app-title">{{item.name.length>15?item.name.slice(0,15)+'...':item.name}}</div>
          </div>
        </div>

      </div>


      <div class="teacher-body-right"
           v-if="page==='教师推荐'">
        <div class="mark-manager-header">
          <div class="left-blue-blank"></div>
          <div class="manager-header-router">
            <div class="header-router-btn">
              <span @click="managePage='table'"
                    :style="{color:managePage==='table'?'black':'#a0a0a0'}">
                推荐列表
              </span>
            </div>
            <div class="header-router-btn"
                 v-if="managePage==='info'">
              ><span @click="managePage='info'"
                    :style="{color:managePage==='info'?'black':'#a0a0a0'}">推荐详情</span>
            </div>
          </div>
        </div>

        <div class="mark-manager-body"
             style="margin-top: 0"
             v-if="taskPage.total>0">
          <div v-if="managePage==='table'" style="margin-top: 0.5vh">
            <div class="search-action">
              <div v-if="searchInput.length>0"
                   class="search-result">搜索到“{{student.taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase())).length}}"个结果</div>
              <el-input v-model="searchInput"
                        placeholder="请输入推荐名"
                        style="width: 10vw;margin: auto 0 auto;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);min-width: 200px"
                        suffix-icon="el-icon-search">
              </el-input>
            </div>

            <el-table v-if="student.taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase())).length>0"
                      ref="multipleTable"
                      :cell-style="{height:'4.5vh',padding:'0px'}"
                      :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'6vh',padding:'0px'}"
                      class="task-table"
                      :data="student.taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase()))"
                      tooltip-effect="dark"
                      border
                      fit
                      highlight-current-row
                      style="width: 100%"
                      @select-all="handleSelectionChange"
                      @select="handleSelectionChange">
              <el-table-column type="index"
                               label="序号"
                               width="70"
                               align="center"></el-table-column>
              <el-table-column prop="name"
                               label="推荐名"
                               align="center"></el-table-column>
              <el-table-column prop="classroom"
                               label="班级"
                               align="center"></el-table-column>
              <el-table-column prop="startTime"
                               label="发布时间"
                               sortable
                               align="center"></el-table-column>
              <el-table-column prop="endTime"
                               label="截止时间"
                               sortable
                               align="center"></el-table-column>
              <el-table-column prop="status"
                               label="状态"
                               align="center">
                <template slot-scope="scope">
                  <div class="status-tag"
                       v-if="scope.row.status==='rejected'">
                    <div class="status-reject"></div>未开始
                  </div>
                  <div class="status-tag"
                       v-if="scope.row.status==='pending'">
                    <div class="status-pending"></div>进行中
                  </div>
                  <div class="status-tag"
                       v-if="scope.row.status==='resolved'">
                    <div class="status-resolve"></div>已完成
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作"
                               width="100"
                               align="center">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row)"
                             type="text"
                             size="small"
                             class="table-to-info"></el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else
                 class="search-no-result">
              <div class="search-no-result-img">

              </div>
            </div>
          </div>

          <div v-if="managePage==='info'"
               class="task-info-body">
            <div class="task-name">
              <div class="task-name-icon icon-name"></div>
              <span class="justify">推荐名称</span><span>：{{selectTask.name}}</span>
            </div>
            <div class="task-name">
              <div class="task-name-icon icon-classroom-info"></div>

              <span class="justify">教师姓名</span><span>：{{selectTask.creator_id}}</span>

            </div>
            <div class="task-name ">
              <div class="task-name-icon icon-time"></div>
              <span class="justify">有效时间</span><span>：{{selectTask.startTime}}&nbsp;：&nbsp;{{selectTask.endTime}}</span>
            </div>
            <div class="task-name">
              <div class="task-name-icon icon-star"></div>
              <span class="justify">推荐内容</span>
            </div>
            <div class="app-card-group" style="  overflow: auto;">
              <div class="app-card"
                   v-for="(item,index) in selectTask.appList"
                   @click="toWebGL(item)">
                <div class="app-icon" :class="{'phy-back':item.subject==='物理','chem-back':item.subject==='化学','bio-back':item.subject==='生物'}">
                  <img :src="item['platforms'][0]['preview_img_uri']"
                       width="120"
                       height="120">
                </div>
                <div class="app-title">{{item.name.length>15?item.name.slice(0,15)+'...':item.name}}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else
             class="no-task-img">
          <div class="no-context">当前班级还没有发布的推荐哦！</div>
          <div class="search-action"
               style="width: 90%;margin: 1vw auto">
            <el-input placeholder="请输入推荐名"
                      style="width: 10vw;margin: auto 0 auto;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);min-width: 200px"
                      suffix-icon="el-icon-search"></el-input>
          </div>
        </div>

        <div class="mark-manager-footer"
             v-if="managePage==='table'">
          <el-pagination style="margin:1vw auto;display: flex;justify-content: center;height: 1vw;"
                         @current-change="handleCurrentChange($event,'task')"
                         hide-on-single-page
                         :current-page="taskPage.page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="taskPage.limit"
                         layout=" prev, pager, next"
                         :total="taskPage.total">
          </el-pagination>
        </div>

      </div>



    </div>
    <el-dialog
      class="dialog-pic"
      center
      top="5vh"
      title=""
      :show-close="false"
      width="70%"
      :before-close="closeDia"
      :visible="appVisible">
        <div style="width: 70vw;height: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
          <img v-if="appVisible" style="width: 65vw" width="100%"  :src="selectApp['platforms'][0].app_uri+'/scoring.png'" alt="图片丢失">
          <div >
            <el-button type="primary"  style="margin: auto 1vw 1vh;width: 5vw" @click="openApp">开始实验</el-button>
            <el-button type="primary"  style="margin: auto 1vw 1vh;width: 5vw" @click="closeDia">取&nbsp;&nbsp;消</el-button>
          </div>

        </div>
<!--      </div>-->
    </el-dialog>
    <el-dialog :visible="logout"
               width="30%"
               title="警告">
      <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
      <template slot="footer">
        <el-button @click="logout=false">取消</el-button>
        <el-button @click="logOut">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import AppCard from '@/components/AppCard'

import {getToken, removeToken} from '@/utils/auth'
import { getStudentSchoolInfo } from '@/api/school'
import { getAppInfo, getJSON, getOnlineAppList } from '@/api/app'
import { getTask } from '@/api/task'
const whiteList=['探究平面镜成像的特点','粗盐中难溶性杂质的去除','观察人血永久涂片']
export default {
  name: 'studentExam',
  components: {
    AppCard
  },
  mounted () {
    let that=this
    document.onclick = function () {

      that.$nextTick(()=>{
        that.showCard=false
      })
    }
    getStudentSchoolInfo().then(res => {
      if (res.status === 'ok') {
        this.student.classroom = res.data.class
        getTask(res.data.class.id, this.taskPage.page, this.taskPage.limit).then(res => {
          if (res.status === 'ok') {
            this.taskPage.page = res.page.current_page
            this.taskPage.total = res.page.total
            this.taskList = []
            let date=new Date()
            for (let i = 0; i < res.data.length; i++) {
              let end=new Date(res.data[i]['end_at'])
              let start=new Date(res.data[i]['start_at'])
              // res.data[i].status === 0 ? 'rejected' : res.data[i].status === 1 ? 'pending' : 'resolved'
              let data = {
                id: res.data[i].id,
                name: res.data[i].name,
                classroom: this.student.classroom.name,
                startTime: res.data[i]['start_at'],
                endTime: res.data[i]['end_at'],
                status: date<start?'rejected':date>end?'resolved':'pending',
                count: '无法获取',
                creator_id: res.data[i]['creator_id'],
                appList: res.data[i].apps
              }

              this.student.taskList.push(data)
            }

          }
        })
      }
    })

    this.router = JSON.parse(localStorage.getItem('router'))
    this.username = localStorage.getItem('username')
    this.account = localStorage.getItem('account')
    let token = localStorage.getItem('token')
    this.loginStatus = token ? true : false
    let userdata = {
      email: localStorage.getItem('email'),
      phone: localStorage.getItem('phone'),
      uid: localStorage.getItem('uid'),
      hasPwd: localStorage.getItem('hasPwd'),
      user_type: localStorage.getItem('user_type'),
      leastDate: localStorage.getItem('leastDate'),
      token: localStorage.getItem('token')
    }
    console.log(localStorage.getItem('email'))
    if (token) {
      this.$store.dispatch('User/reLogin', userdata)
    }
    for (let i = 0; i < this.routerList.length; i++) {
      if (this.routerList[i].active) {
        this.page = this.routerList[i].name
      }
    }

  },
  data () {
    return {
      isSeller:false,
      whiteList:whiteList,
      taskPage: {
        page: 1,
        limit: 13,
        total: 1
      },
      appPage: {
        page: 1,
        limit: 20,
        total: 1
      },
      taskAppPage:{
        page: 1,
        limit: 8,
        total: 0
      },
      excel:{
        title:'',
        tableList:[],
        itemContent:'',
        sumContent:'',
        studentMark:{
          score:[],
          sum:''
        },
        step:[],
        sumMark:''
      },
      selectApp:'',
      logout: false,
      account: '',
      username: '',
      showCard: false,
      router: [],
      page: '自主练习',
      managePage: 'table',
      loginStatus: getToken() ? true : false,
      formData: {
        taskName: '',
        time: [],
        appList: []
      },
      dialogVisible: false,
      delVisible: false,
      appVisible: false,
      searchInput: '',
      searchResult: 0,
      selectTask: {},
      selectAppInTask: {},
      selectStudent: {
      },
      taskAppList:[],
      searchAppInput: '',
      //////////多选框////////////
      checkAll: true,
      checkedCities: ['物理', '化学', '生物'],
      subjects: ['物理', '化学', '生物'],
      isIndeterminate: true,
      //////////////////////////////
      student: {
        classroom: '',
        taskList: [],
      },
      delList: [],
      studentExamList: [
      ],
      taskname: 'wkq',
      classroomList: [
        { name: '七年一班', id: 71 },
        { name: '八年一班', id: 81 },
        { name: '九年一班', id: 91 },
      ],
      routerList: [
        { icon: '/exam/icon_自主练习', name: '自主练习', path: '/train', active: true },
        { icon: '/exam/icon_我的任务', name: '教师推荐', path: '/tasks', active: false },

      ],
      appList: []
    }

  },
  watch: {
    searchAppInput: function () {
      if (this.searchAppInput.length <= 0) {
        for (let i = 0; i < this.appList.length; i++) {
          this.appList[i].show = true
        }
      }
    },
  },
  created() {
      if(localStorage.getItem('isSeller')){
        if(localStorage.getItem('isSeller')=='true'){
          this.isSeller=true
        }
        else {
          this.isSeller=false
        }
      }
      else{
        removeToken()
        this.$router.push('/login?way=登录&info=登录信息丢失请重新登录')
      }
      getOnlineAppList(this.appPage.page, this.appPage.limit,'&usage=模拟考试').then(res => {
        if (res.status === 'ok') {
          this.appPage.page=res.page.current_page
          this.appPage.limit=res.page.per_page
          this.appPage.total=res.page.total
          for (let i = 0; i < res.data.length; i++) {
            console.log(res.data[i])
            res.data[i]['show'] = true
            if (this.appList.findIndex(item => item.id === res.data[i].id) === -1) {
              this.appList.push(res.data[i])
            }
          }
        }
      })
      window.addEventListener('storage', event => {
        if (event.key === 'deleteList') {
          // let deleteStr=event.newValue.split(',')
          // console.log(deleteStr)
          // let req=window.indexedDB.open('UnityCache')
          // req.onsuccess=e=>{
          //   let db=e.target.result
          //   let get= db.transaction(["XMLHttpRequest"],'readwrite').objectStore("XMLHttpRequest").getAll()
          //   get.onsuccess=e=>{
          //     console.log(e.target.result)
          //     for(let i=0;i<deleteStr.length;i++){
          //       let del=db.transaction(["XMLHttpRequest"],'readwrite').objectStore("XMLHttpRequest").delete(deleteStr[i])
          //       del.onsuccess=e=>{
          //         console.log('success')
          //       }
          //       del.onerror=e=>{
          //         console.log('error')
          //       }
          //     }
          //   }
          // }
          console.log('12341242')
          console.log(window.indexedDB.deleteDatabase('UnityCache'))
        }
      })
  },
  methods: {
    clickZone(e){
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
      this.showCard=!this.showCard
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? ['物理', '化学', '生物'] : [];
      this.isIndeterminate = false;
      for (let i = 0; i < this.appList.length; i++) {
        this.appList[i].show = val
      }
    },
    searchApp () {
      for (let i = 0; i < this.appList.length; i++) {
        if (this.appList[i].name.indexOf(this.searchAppInput) !== -1) {
          this.appList[i].show = true
        }
        else {
          this.appList[i].show = false
        }
      }

    },
    handleCheckedCitiesChange (value) {
      let that = this
      for (let i = 0; i < that.appList.length; i++) {
        that.appList[i].show = false
        if (value.find(item => item === that.appList[i].subject)) {
          that.appList[i].show = true
        }
        console.log(this.appList)
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.subjects.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.subjects.length;
    },
    closeDia () {
      this.appVisible = false
    },
    refreshExcel(){
      let data= {
        title: '',
        tableList: [],
        itemContent: '',
        sumContent: '',
        studentMark: {
          score: [],
          sum: ''
        },
        step: [],
        sumMark: ''
      }
      this.excel=data

    },
    openApp(){
      let url=this.$router.resolve({
        path: '/webGL',
        query: {
          name:this.selectApp.name,
          app_uri:this.selectApp['platforms'][0].app_uri,
          platform:'webgl',
          app_platform_id: this.selectApp['platforms'][0].id,
          app_id: this.selectApp.id,
          mode: 0,
          publisher: this.selectApp.publisher,
          grade: this.selectApp.grade,
          subject: this.selectApp.subject,
          chapter: this.selectApp.chapter
        }
      })
      window.open(url.href,'_blank')
    },
    openExcel(item){
      if(this.isSeller){
        if(!whiteList.find(i=>i==item.name)){
          this.$message.error('当前账号无权查看')
        }
        else {
          console.log(item)
          this.selectApp=item
          this.refreshExcel()
          getJSON('模考计分表_'+item.id).then(res=>{
            if(res.status==='ok'){
              let excelJson=JSON.parse(res.data)
              this.excel.step=[]
              console.log(excelJson)
              // this.excel.title=excelJson.title
              // this.excel.tableList=excelJson.tableList.split('|')
              // this.excel.itemContent=excelJson.itemContent
              // this.excel.sumContent=excelJson.sumContent
              // this.excel.sumMark=excelJson.sumMark
              //
              // // {content:'123',mark:'10分'}
              // let step=excelJson['stepContent'].split('|')
              // let mark=excelJson['stepMark'].split('|')
              // for(let i=0;i<step.length-1;i++){
              //   let data={
              //     content:step[i],
              //     mark:mark[i]
              //   }
              //   this.excel.step.push(data)
              // }
            }
          })
          this.appVisible=true
        }
      }
      else {
        console.log(item)
        this.selectApp=item
        this.refreshExcel()
        getJSON('模考计分表_'+item.id).then(res=>{
          if(res.status==='ok'){
            let excelJson=JSON.parse(res.data)
            this.excel.step=[]
            console.log(excelJson)
            // this.excel.title=excelJson.title
            // this.excel.tableList=excelJson.tableList.split('|')
            // this.excel.itemContent=excelJson.itemContent
            // this.excel.sumContent=excelJson.sumContent
            // this.excel.sumMark=excelJson.sumMark
            //
            // // {content:'123',mark:'10分'}
            // let step=excelJson['stepContent'].split('|')
            // let mark=excelJson['stepMark'].split('|')
            // for(let i=0;i<step.length-1;i++){
            //   let data={
            //     content:step[i],
            //     mark:mark[i]
            //   }
            //   this.excel.step.push(data)
            // }
          }
        })
        this.appVisible=true
      }
    },
    handleCurrentChange (page, target) {
      if (target === 'task') {
        getTask(this.student.classroom.id, page, this.taskPage.limit).then(res => {
          if (res.status === 'ok') {
            this.taskPage.page = res.page.current_page
            this.taskPage.total = res.page.total
            this.student.taskList = []
            let date=new Date()
            for (let i = 0; i < res.data.length; i++) {
              let end=new Date(res.data[i]['end_at'])
              let start=new Date(res.data[i]['start_at'])
              // res.data[i].status === 0 ? 'rejected' : res.data[i].status === 1 ? 'pending' : 'resolved'
              let data = {
                id: res.data[i].id,
                name: res.data[i].name,
                classroom: this.student.classroom.name,
                startTime: res.data[i]['start_at'],
                endTime: res.data[i]['end_at'],
                status: date<start?'rejected':date>end?'resolved':'pending',
                count: '无法获取',
                creator_id: res.data[i]['creator_id'],
                appList: res.data[i].apps
              }
              this.student.taskList.push(data)
            }

          }
        })
      }
      else if(target==='task-app'){

      }
      else{
        getOnlineAppList(page, this.appPage.limit,'&usage=模拟考试').then(res => {
          if (res.status === 'ok') {
            this.appPage.page=res.page.current_page
            this.appPage.limit=res.page.per_page
            this.appPage.total=res.page.total
            for (let i = 0; i < res.data.length; i++) {
              console.log(res.data[i])
              res.data[i]['show'] = true
              if (this.appList.findIndex(item => item.id === res.data[i].id) === -1) {
                this.appList.push(res.data[i])
              }
            }
          }
        })
      }
    },
    handleSelectionChange (rowlist) {
      this.delList = rowlist
      console.log(this.delList)
    },
    handleClick (scope) {
      console.log(scope)
      if(scope.status==='pending'){
        this.managePage = 'info'
        this.selectTask = scope
      }
      else{
        this.$message.error('当前推荐无法查看')
      }
    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      localStorage.clear()
      window.close()
      // setTimeout(() => {
      //
      //   if (this.$route.path !== '/') {
      //     this.$router.push('/')
      //   }
      //   else {
      //     this.$router.go(0);
      //   }
      // }, 500)
    },
    changeClassroom (select) {
      console.log(select)
    },
    switchPage (name) {
      let that = this
      that.$nextTick(() => {
        for (let i = 0; i < that.routerList.length; i++) {
          that.routerList[i].active = false
        }
        that.routerList.find(item => item.name === name).active = true
        that.page = name
      })
      if (name === '自主练习') {
        // {name:'测试',img:'/banner1.png',show:true,subject:'物理'},
        getOnlineAppList(this.appPage.page, this.appPage.limit,'&usage=模拟考试').then(res => {
          if (res.status === 'ok') {
            this.appPage.page=res.page.current_page
            this.appPage.limit=res.page.per_page
            this.appPage.total=res.page.total
            for (let i = 0; i < res.data.length; i++) {
              console.log(res.data[i])
              res.data[i]['show'] = true
              if (this.appList.findIndex(item => item.id === res.data[i].id) === -1) {
                this.appList.push(res.data[i])
              }
            }
          }
        })
      }

    },
    handleDeleteTask () {
      this.delVisible = false
      console.log(this.delList.length)
      for (let i = 0; i < this.delList.length; i++) {
        let index = this.taskList.findIndex(item => item === this.delList[i])
        console.log(index)
        if (index !== -1) {
          this.taskList.splice(index, 1)
        }

      }
      console.log(this.taskList)
      this.$refs.multipleTable.clearSelection();
    },
    toWebGL (item) {
      console.log(item)
      // console.log(this.selectApp['platforms'][0].app_uri)
      let url=this.$router.resolve({
        path: '/webGL',
        query: {
          platform: 'webgl',
          mode: 2,
          user_id:localStorage.getItem('uid'),
          name:item.name,
          app_uri:item['platforms'][0].app_uri,
          subject: item.subject,
          publisher: item.publisher,
          grade: item.grade,
          chapter: item.chapter,
          task_id: this.selectTask.id,
          app_id: item.id,
          app_platform_id: item['platforms'][0].id
        }
      })
      window.open(url.href,'_blank')
    },
    changeRight (title) {
      if(title==='toHome'){
        this.$router.push('/home')
      }
    },

  }

}
</script>

<style scoped>
.task-table /deep/ .cell{
  white-space: nowrap;
}
.header {
  width: 100%;
  height: 4vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 3vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  cursor: pointer;
  width: 8vw;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.5rem;
  text-align: center;
}

.teacher-body {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 85%;
  height: 85vh;
  margin: 2vw auto 1vw;
  display: flex;
  flex-wrap: nowrap;
}
.teacher-body-left {
  height: 100%;
  width: 13vw;
  background-color: #e8e8e9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.switch-classroom {
  margin-top: 0.5vw;
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.icon-classroom {
  background-image: url("http://data.xiyilab.com/web/main/static/home/班级.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 1vw;
  height: 1vw;
  margin: auto 0.5vw auto;
}
.router-btn-group {
  margin-top: 1vw;
  height: 85%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.router-btn {
  width: 100%;
  height: 4.25vh;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.router-btn-icon {
  width: 1vw;
  height: 1vw;
  margin-left: 3.5vw;
  margin-right: 1vw;
}
.router-btn-text {
  line-height: 4.25vh;
  font-size: 0.8vw;
}
.router-btn-right-line {
  margin-left: auto;
  height: 2vh;
  margin-top: auto;
  margin-bottom: auto;
  width: 3px;
  background-color: #5eb2f7;
}
.teacher-body-right {
  width: 85%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.select-app-card {
  width: 90%;
  height: 12%;
  min-height: 80px;
  display: flex;
  margin: 1vw auto 0;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
}
.subject-select-btn-group {
  margin-top: 0;
  display: flex;
  flex-wrap: nowrap;
  height: 40px;
  width: 50%;
  line-height: 40px;
  white-space: nowrap;
  justify-content: flex-end;
}

.task-name-input {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  height: 40px;
  margin: 0 0 10px;
  white-space: nowrap;
  line-height: 40px;
}
.app-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 65vw;
  margin: 0 auto 1vh;
  scrollbar-width: none; /* Firefox */
}
.app-body::-webkit-scrollbar{
  display: none;
}
.app-card {
  width: 13vw;
  height: 9vw;
  margin: 0.75vw 1.5vw 0.75vw;
  min-height: 150px;
  min-width: 150px;
  position: relative;
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
  background-color: rgba(161, 184, 202, 0.1);
}
.app-card:hover {
  color: #5eb2f7;
}
.app-card:hover .app-icon {
}
.app-card:hover .app-checkbox {
  visibility: inherit;
}
.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 7vw;
  min-height: 120px;
  min-width: 120px;
  border-radius: 4px;
}

.app-title {
  width: 100%;
  text-align: center;
  font-weight: 500;
  font-size: 0.8vw;
  line-height: 2vw;
  height: 2vw;
  color: inherit;
}

.mark-manager-header {
  width: 90%;
  margin: 0 auto 1rem;
  height: 5rem;

  border-bottom: 1px #efefef solid;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;

  justify-content: flex-start;
}

.header-router-btn {
  display: inline-block;
  cursor: pointer;
}
.left-blue-blank {
  margin-top: 1.75rem;
  margin-left: 0;
  width: 3px;
  background-color: #5eb2f7;
  height: 1.5rem;
}
.manager-header-router {
  height: 2rem;
  line-height: 5rem;
  margin-left: 2vw;
  font-size: 0.7vw;
}
.mark-manager-body {
  height: 80%;
  margin: auto;
  width: 90%;
}
.mark-manager-footer {
  height: 3vw;
  min-height: 60px;
  margin: 0 auto;
  width: 90%;
}
.no-task-img {
  width: 100%;
  height: 100%;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/没有任务.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
}

.search-action {
  width: 100%;
  height: 40px;
  margin: 0 0 1vw;
  display: flex;
  justify-content: flex-end;
}
.table-to-info {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/查看详情.png");

  width: 18px;
  width: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.status-tag {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  width: 4vw;
  height: 16px;
  line-height: 16px;
}
.status-reject {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/未开始.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.status-pending {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/进行中.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.status-resolve {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/已完成.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.task-info-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.task-name {
  width: 90%;
  margin-left: 1vw;
  justify-content: flex-start;
  display: flex;
  height: 2vw;
  line-height: 2vw;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.8vw;
  letter-spacing: 1px;
}
.task-name-icon {
  text-align: justify;
  width: 16px;
  margin: auto 0.5vw auto;
  height: 16px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.icon-name {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/名称小图标.png");
}
.icon-classroom-info {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/班级小图标.png");
}
.icon-time {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/时间小图标.png");
}
.icon-star {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/icon_任务内容.png");
}
/*.justify {*/
/*  width: 4rem;*/
/*  display: inline-block;*/
/*  text-align: justify;*/
/*  vertical-align: top;*/
/*}*/
/*.justify::after {*/
/*  width: 100%;*/
/*  display: inline-block;*/
/*  content: "";*/
/*}*/
.app-card-group {
  width: 100%;
  height: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  scrollbar-width: none; /* Firefox */
}
.app-card-group::-webkit-scrollbar{
  display: none;
}
.search-result {
  height: 40px;
  line-height: 40px;
  margin-top: auto;
  margin-left: 1vw;
  margin-right: auto;
}
.search-no-result-img {
  width: 100%;
  height: 32vw;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/无搜索结果.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.search-btn {
  position: absolute;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/搜索 (1).png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 16px;
  height: 20px;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.clear-btn{
  position: absolute;
  font-size: 20px;
  top: 10px;
  right: 30px;
  cursor: pointer;
}
.excel{
  width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.excel img{
  width: 65%;
}
.excel-title{
  width: 100%;
  height: 10vh;
  border: 1px black solid;
  display: flex;
  justify-content: center;
  align-items: center;
}
.excel-tableList{
  width: 100%;
  height: 100%;
  border: 1px black solid;
  border-top-width:0px ;
  border-right-width:0px ;
  display: flex;
  flex-direction: column;
}
.excel-step{
  display: flex;
  height: 100%;
  border-width:0px;
}
.excel-item{
  width: 100%;
  height: 5vh;
  border: 1px black solid;
  border-left-width:0px ;
  border-top-width:0px ;
  display: flex;
}
.excel-sum{
  width: 100%;
  height: 5vh;

  border: 1px black solid;
  border-top-width:0px ;
  display: flex;

}
.task-app-pagination{
  width: 100%;
  height: 2vw;
  border: 1px red solid;
}
.phy-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/物理.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.chem-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/化学.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bio-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/生物.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.dialog-pic /deep/ .el-dialog__header{
  background-color: rgb(64, 158, 255);
}
.dialog-pic /deep/ .el-dialog__body{
  padding: 0;
}
.no-context{
  position: absolute;
  font-family: test;
  font-weight: 400;
  top: 15vh;
  left: 20vw;
  height: 40px;
  font-size:1vw;
  text-align: center;
  color: black;
  line-height: 40px;
  cursor: pointer;
}
.skin{
  border-radius: 10px   10px 0 0;
  position: absolute;
  width: 100%;
  height: 22vh;
  background-color: rgba(0,0,0,.25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.skin-cir{
  position: relative;

  background-image: url("http://data.xiyilab.com/web/main/static/app/圆.png");
  width: 13vw;
  height: 12.2vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.skin-title{
  /*background-image: url("http://data.xiyilab.com/web/main/static/app/当前账号无权查看.png");*/
  min-width: 5.2vw;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 1vw;
}
.skin-lock{
  position: absolute;
  top:1.5vw;
  right:0.5vw;
  margin-top: 1.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/app/锁.png");
  width: 1.2vw;
  height: 1.2vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
